import { React, useContext, useState } from "react";
import { AppContext } from "../../context/AppContext";
import { Link, useNavigate } from "react-router-dom";
import Logout from "../../assets/images/import_icon.svg";
import Share from "../../assets/images/XMLID_1022_.svg";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Nav from "react-bootstrap/Nav";
import option from "../../assets/images/option-three-dot.svg";
import { Col, Dropdown, Modal } from "react-bootstrap";
import { motion } from "framer-motion";
import MapComponent from "../../sharedComponent/MapComponent";
import { useTranslation } from "react-i18next";
import PreviousButton from "../../sharedComponent/PreviousButton";
import NextButton from "../../sharedComponent/Nextbutton";
import ExistButton from "../../sharedComponent/ExistButton";
import InfoComponent from "../../sharedComponent/SupportHelp/InfoComponent";

const ParkingManagement = ({ onClick }) => {
  const { sidebar, setSidebar, Dark, setDark, slider, setSlider } =
    useContext(AppContext);
  const [tabClicked, setTabClicked] = useState(false);
  const [navClicked, setNavClicked] = useState(false);
  const { t, i18n } = useTranslation();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const aninations = {
    initial: { opacity: 0, x: 400 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };
  const navigate = useNavigate();
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    navigate("/ParkingManagement/ParkingSlot/Add/Add");
  };
  const handleClickPrevious = () => {
    navigate("/DispatchCustomer");
  };
  return (
    <>
      <motion.div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
        variants={aninations}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1 }}
      >
        <div id="cx-wrapper" className="Parking_Slot">
          <div className="upperMainSet">
            <div className="row top-content">
              <div className="col-lg-8 col-md-12 arrange-margin left">
                <div className="row p-0">
                  <div className="col-md-4">
                    <div className="weekCounter">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Slot Name"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="weekCounter">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Slot Code"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="weekCounter">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Address"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-12 mainCol4 right">
                <div className="leftSideSec">
                  <Link
                    to="/ParkingManagement/ParkingSlot/Add/Add"
                    className="addParkBtn"
                  >
                    <button>+ {t("Add Parking Station")}</button>
                  </Link>
                  <Link to="#">
                    <div className="inconMain">
                      <img src={Logout} alt="" />
                    </div>
                  </Link>
                  {/* <Link to="#">
                    <div className="inconMain left-margin me-0">
                      <img src={Share} alt="" />
                    </div>
                  </Link> */}
                  <div style={{ marginRight: "10px" }} />
                  <div className="right-export-btn-section-wrapper">
                    <div className="c-pointer me-2"></div>

                    <div className="md_dropdown">
                      <Dropdown>
                        <Dropdown.Toggle
                          id="dropdown-basic"
                          className="export-toggle"
                        >
                          <p className="Export_Text">{t("Export")}</p>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item>
                            <Link
                              // onClick={() => getExportChat()}
                              className="d-block"
                            >
                              {t("PDF")}
                            </Link>
                          </Dropdown.Item>

                          <Dropdown.Item>
                            <Link
                              // onClick={() => downLoadExcelSheet()}
                              className="d-block"
                            >
                              {t("Excel")}
                            </Link>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row body-content">
              <div className="col-lg-8 col-md-12">
                <div className="mainMape">
                  <MapComponent />

                  {tabClicked ? (
                    <div
                      className="innerMapDetails"
                      id="model-responsive-on-map"
                    >
                      <div className="headingDetails">
                        <div className="headingTxt">
                          <p className="heading">
                            {t("Parking Station Details")}
                          </p>
                        </div>
                        <div className="customer-option">
                          <Dropdown>
                            <Dropdown.Toggle id="dropdown-basic">
                              <img src={option} alt="" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item>
                                <Link to="/EditParkingSlot" className="d-block">
                                  {t("Edit")}
                                </Link>
                              </Dropdown.Item>
                              <Dropdown.Item>
                                <Link
                                  tp="#"
                                  onClick={() => setShow(true)}
                                  className="d-block"
                                >
                                  {t("Delete")}
                                </Link>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                      <div className="innerCOntent">
                        <div className="row">
                          <div className="col-lg-3 col-md-4 col-sm-5 dividedCol form_input_main">
                            <p className="paraHead">{t("Station Name")}</p>
                            <p className="paraVal">Parking Slot 1</p>
                          </div>
                          <div className="col-lg-3 col-md-4 col-sm-5 dividedCol form_input_main">
                            <p className="paraHead">{t("Station Code")}</p>
                            <p className="paraVal">456789</p>
                          </div>
                          <div className="col-lg-3 col-md-4 col-sm-5 dividedCol form_input_main">
                            <p className="paraHead">{t("Parking Capacity")}</p>
                            <p className="paraVal">10</p>
                          </div>
                          <div className="col-md-12 dividedCol form_input_main">
                            <p className="paraHead">{t("Address")}</p>
                            <p className="paraVal">
                              SGRA 82, Shanti Gardens Third St, Thrimoorthy
                              Nagar, Kamaleshwaram, Thiruvananthapuram, Kerala
                              695009, India
                            </p>
                          </div>
                          <div className="col-lg-4 col-md-6 col-sm-6 dividedCol form_input_main">
                            <p className="paraHead">
                              {t("Slot GPS Lattitude")}
                            </p>
                            <p className="paraVal">8.465844813567859</p>
                          </div>
                          <div className="col-lg-4 col-md-6 col-sm-6 dividedCol form_input_main">
                            <p className="paraHead">
                              {t("Slot GPS Longitude")}
                            </p>
                            <p className="paraVal">76.9438642156782</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null || navClicked ? (
                    <div className="innerMapDetails">
                      <div className="headingDetails">
                        <div className="headingTxt">
                          <p className="heading">
                            {t("Parking Station Details")}
                          </p>
                        </div>
                        <div className="AddParkBtn">
                          <Link
                            to="/ParkingManagement/ParkingSlot/Add/Add"
                            className="addLink"
                          >
                            <button> + {t("Add Parking Station")}</button>
                          </Link>
                        </div>
                      </div>
                      <div className="innerCOntent">
                        <div className="row">
                          <div className="col-md-12 dividedCol">
                            <p className="paraHead">{t("Address")}</p>
                            <p className="paraVal">
                              SGRA 82, Shanti Gardens Third St, Thrimoorthy
                              Nagar, Kamaleshwaram, Thiruvananthapuram, Kerala
                              695009, India
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-4 col-md-12">
                <div className="tabsCon">
                  <Tab.Container
                    id="left-tabs-example"
                    className="td-tab-wrapper"
                    defaultActiveKey="0"
                  >
                    <Nav
                      variant="pills"
                      className="td-nav"
                      id="InnerTabNew_Two"
                    >
                      <Nav.Item className="td-tab" id="text_small_Tab_first">
                        <Nav.Link className="td-link" eventKey="0">
                          {t("All")}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item className="td-tab" id="text_small_Tab_second">
                        <Nav.Link className="td-link" eventKey="1">
                          {t("Suggested Parking Station")}
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>

                    <Col sm={12} className="">
                      <Tab.Content>
                        <Tab.Pane eventKey="0">
                          <div id="navPills">
                            <Nav variant="pills" className="flex-column">
                              <Nav.Item
                                onClick={() => {
                                  setTabClicked(true);
                                  setNavClicked(false);
                                }}
                              >
                                <Nav.Link eventKey="first">
                                  <div className="AllFlexNav">
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Name")}
                                      </p>
                                      <p className="paraNavTxt">
                                        Redbytes Parking
                                      </p>
                                    </div>
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Code")}
                                      </p>
                                      <p className="paraNavTxt">Test1234</p>
                                    </div>
                                    <div>
                                      <p className="paraNav">{t("Address")}</p>
                                      <p className="paraNavTxt">
                                        Vishrantwadi, Kalas...
                                      </p>
                                    </div>
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item
                                onClick={() => {
                                  setTabClicked(true);
                                  setNavClicked(false);
                                }}
                              >
                                <Nav.Link eventKey="two">
                                  <div className="AllFlexNav">
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Name")}
                                      </p>
                                      <p className="paraNavTxt">
                                        Redbytes Parking
                                      </p>
                                    </div>
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Code")}
                                      </p>
                                      <p className="paraNavTxt">Test1234</p>
                                    </div>
                                    <div>
                                      <p className="paraNav">{t("Address")}</p>
                                      <p className="paraNavTxt">
                                        Vishrantwadi, Kalas...
                                      </p>
                                    </div>
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item
                                onClick={() => {
                                  setTabClicked(true);
                                  setNavClicked(false);
                                }}
                              >
                                <Nav.Link eventKey="three">
                                  <div className="AllFlexNav">
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Name")}
                                      </p>
                                      <p className="paraNavTxt">
                                        Redbytes Parking
                                      </p>
                                    </div>
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Code")}
                                      </p>
                                      <p className="paraNavTxt">Test1234</p>
                                    </div>
                                    <div>
                                      <p className="paraNav">{t("Address")}</p>
                                      <p className="paraNavTxt">
                                        Vishrantwadi, Kalas...
                                      </p>
                                    </div>
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item
                                onClick={() => {
                                  setTabClicked(true);
                                  setNavClicked(false);
                                }}
                              >
                                <Nav.Link eventKey="four">
                                  <div className="AllFlexNav">
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Name")}
                                      </p>
                                      <p className="paraNavTxt">
                                        Redbytes Parking
                                      </p>
                                    </div>
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Code")}
                                      </p>
                                      <p className="paraNavTxt">Test1234</p>
                                    </div>
                                    <div>
                                      <p className="paraNav">{t("Address")}</p>
                                      <p className="paraNavTxt">
                                        Vishrantwadi, Kalas...
                                      </p>
                                    </div>
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item
                                onClick={() => {
                                  setTabClicked(true);
                                  setNavClicked(false);
                                }}
                              >
                                <Nav.Link eventKey="five">
                                  <div className="AllFlexNav">
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Name")}
                                      </p>
                                      <p className="paraNavTxt">
                                        Redbytes Parking
                                      </p>
                                    </div>
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Code")}
                                      </p>
                                      <p className="paraNavTxt">Test1234</p>
                                    </div>
                                    <div>
                                      <p className="paraNav">{t("Address")}</p>
                                      <p className="paraNavTxt">
                                        Vishrantwadi, Kalas...
                                      </p>
                                    </div>
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item
                                onClick={() => {
                                  setTabClicked(true);
                                  setNavClicked(false);
                                }}
                              >
                                <Nav.Link eventKey="six">
                                  <div className="AllFlexNav">
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Name")}
                                      </p>
                                      <p className="paraNavTxt">
                                        Redbytes Parking
                                      </p>
                                    </div>
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Code")}
                                      </p>
                                      <p className="paraNavTxt">Test1234</p>
                                    </div>
                                    <div>
                                      <p className="paraNav">{t("Address")}</p>
                                      <p className="paraNavTxt">
                                        Vishrantwadi, Kalas...
                                      </p>
                                    </div>
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item
                                onClick={() => {
                                  setTabClicked(true);
                                  setNavClicked(false);
                                }}
                              >
                                <Nav.Link eventKey="seven">
                                  <div className="AllFlexNav">
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Name")}
                                      </p>
                                      <p className="paraNavTxt">
                                        Redbytes Parking
                                      </p>
                                    </div>
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Code")}
                                      </p>
                                      <p className="paraNavTxt">Test1234</p>
                                    </div>
                                    <div>
                                      <p className="paraNav">{t("Address")}</p>
                                      <p className="paraNavTxt">
                                        Vishrantwadi, Kalas...
                                      </p>
                                    </div>
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item
                                onClick={() => {
                                  setTabClicked(true);
                                  setNavClicked(false);
                                }}
                              >
                                <Nav.Link eventKey="eight">
                                  <div className="AllFlexNav">
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Name")}
                                      </p>
                                      <p className="paraNavTxt">
                                        Redbytes Parking
                                      </p>
                                    </div>
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Code")}
                                      </p>
                                      <p className="paraNavTxt">Test1234</p>
                                    </div>
                                    <div>
                                      <p className="paraNav">{t("Address")}</p>
                                      <p className="paraNavTxt">
                                        Vishrantwadi, Kalas...
                                      </p>
                                    </div>
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item
                                onClick={() => {
                                  setTabClicked(true);
                                  setNavClicked(false);
                                }}
                              >
                                <Nav.Link eventKey="nine">
                                  <div className="AllFlexNav">
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Name")}
                                      </p>
                                      <p className="paraNavTxt">
                                        Redbytes Parking
                                      </p>
                                    </div>
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Code")}
                                      </p>
                                      <p className="paraNavTxt">Test1234</p>
                                    </div>
                                    <div>
                                      <p className="paraNav">{t("Address")}</p>
                                      <p className="paraNavTxt">
                                        Vishrantwadi, Kalas...
                                      </p>
                                    </div>
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item
                                onClick={() => {
                                  setTabClicked(true);
                                  setNavClicked(false);
                                }}
                              >
                                <Nav.Link eventKey="ten">
                                  <div className="AllFlexNav">
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Name")}
                                      </p>
                                      <p className="paraNavTxt">
                                        Redbytes Parking
                                      </p>
                                    </div>
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Code")}
                                      </p>
                                      <p className="paraNavTxt">Test1234</p>
                                    </div>
                                    <div>
                                      <p className="paraNav">{t("Address")}</p>
                                      <p className="paraNavTxt">
                                        Vishrantwadi, Kalas...
                                      </p>
                                    </div>
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item
                                onClick={() => {
                                  setTabClicked(true);
                                  setNavClicked(false);
                                }}
                              >
                                <Nav.Link eventKey="ten">
                                  <div className="AllFlexNav">
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Name")}
                                      </p>
                                      <p className="paraNavTxt">
                                        Redbytes Parking
                                      </p>
                                    </div>
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Code")}
                                      </p>
                                      <p className="paraNavTxt">Test1234</p>
                                    </div>
                                    <div>
                                      <p className="paraNav">{t("Address")}</p>
                                      <p className="paraNavTxt">
                                        Vishrantwadi, Kalas...
                                      </p>
                                    </div>
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item
                                onClick={() => {
                                  setTabClicked(true);
                                  setNavClicked(false);
                                }}
                              >
                                <Nav.Link eventKey="ten">
                                  <div className="AllFlexNav">
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Name")}
                                      </p>
                                      <p className="paraNavTxt">
                                        Redbytes Parking
                                      </p>
                                    </div>
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Code")}
                                      </p>
                                      <p className="paraNavTxt">Test1234</p>
                                    </div>
                                    <div>
                                      <p className="paraNav">{t("Address")}</p>
                                      <p className="paraNavTxt">
                                        Vishrantwadi, Kalas...
                                      </p>
                                    </div>
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item
                                onClick={() => {
                                  setTabClicked(true);
                                  setNavClicked(false);
                                }}
                              >
                                <Nav.Link eventKey="ten">
                                  <div className="AllFlexNav">
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Name")}
                                      </p>
                                      <p className="paraNavTxt">
                                        Redbytes Parking
                                      </p>
                                    </div>
                                    <div>
                                      <p className="paraNav">
                                        {t("Station Code")}
                                      </p>
                                      <p className="paraNavTxt">Test1234</p>
                                    </div>
                                    <div>
                                      <p className="paraNav">{t("Address")}</p>
                                      <p className="paraNavTxt">
                                        Vishrantwadi, Kalas...
                                      </p>
                                    </div>
                                  </div>
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="1">
                          <Nav
                            variant="pills"
                            className="flex-column"
                            id="navPills"
                          >
                            <Nav.Item
                              onClick={() => {
                                setTabClicked(false);
                                setNavClicked(true);
                              }}
                            >
                              <Nav.Link eventKey="first">
                                <div className="row">
                                  <div className="col-md-12 parkingSLotCOl">
                                    <p className="paraNav">{t("Address")}</p>
                                    <p className="paraNavTxt">
                                      Vishrantwadi, Kalas Road, Pune,
                                      Maharashtra.
                                    </p>
                                  </div>
                                </div>
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item
                              onClick={() => {
                                setTabClicked(false);
                                setNavClicked(true);
                              }}
                            >
                              <Nav.Link eventKey="second">
                                <div className="row">
                                  <div className="col-md-12 parkingSLotCOl">
                                    <p className="paraNav">{t("Address")}</p>
                                    <p className="paraNavTxt">
                                      Vishrantwadi, Kalas Road, Pune,
                                      Maharashtra.
                                    </p>
                                  </div>
                                </div>
                              </Nav.Link>
                            </Nav.Item>

                            <Nav.Item
                              onClick={() => {
                                setTabClicked(false);
                                setNavClicked(true);
                              }}
                            >
                              <Nav.Link eventKey="third">
                                <div className="row">
                                  <div className="col-md-12 parkingSLotCOl">
                                    <p className="paraNav">{t("Address")}</p>
                                    <p className="paraNavTxt">
                                      Vishrantwadi, Kalas Road, Pune,
                                      Maharashtra.
                                    </p>
                                  </div>
                                </div>
                              </Nav.Link>
                            </Nav.Item>
                          </Nav>
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Tab.Container>
                </div>
              </div>
            </div>
          </div>
          {slider ? <ExistButton onClose={() => setSlider(false)} /> : null}
          {!slider && <NextButton onClick={handleClick} />}
          {!slider && <InfoComponent />}
        </div>
      </motion.div>

      {/* Delete Modal Start */}
      <Modal show={show} onHide={handleClose} centered className="common-model">
        <Modal.Header closeButton>
          <Modal.Title>{t("Delete Parking Station")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t("Are you sure you want to delete this parking Station")} ?
        </Modal.Body>
        <Modal.Footer className="pop-up-modal-footer btn-wrapper">
          <div class="btn-wrapper">
            <button className="cx-btn-1" onClick={handleClose}>
              {t("Cancel")}
            </button>
            <button className="cx-btn-2" onClick={handleClose}>
              {t("Yes")}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      {/* Delete Modal End */}
    </>
  );
};

export default ParkingManagement;
